var _path, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnRefundList18 = function SvgLightIcnRefundList18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6DC5FF",
    fillRule: "evenodd",
    d: "M7.5 4.5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h8.385v-3.033a1.5 1.5 0 0 1 1.5-1.5H20.5V6.5a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAF0FF",
    d: "M20.5 16.967h-3.115a1.5 1.5 0 0 0-1.5 1.5V21.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.926 15.5c-.45 0-.845-.296-.972-.727l-1.243-4.227a.824.824 0 1 1 1.593-.413l.697 3.093a.032.032 0 0 0 .061 0l.805-3.061a.905.905 0 0 1 1.75 0l.811 3.079a.032.032 0 0 0 .062-.002l.697-3.109a.823.823 0 1 1 1.593.413l-1.242 4.223a1.019 1.019 0 0 1-1.953.007l-.812-2.689a.034.034 0 0 0-.064 0l-.813 2.693c-.129.427-.523.72-.97.72"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1.7,
    x: 7.7,
    y: 11,
    fill: "#fff",
    rx: 0.85
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 1.7,
    x: 15,
    y: 11,
    fill: "#fff",
    rx: 0.85
  })));
};
export default SvgLightIcnRefundList18;